import styled from 'styled-components';

export const SectionContent = styled.div`
    padding: 16px 24px 20px;
    flex: 1;
    margin: 0;
    font-family: ${(props) => props.theme.app.font};
    color: ${(props) => props.theme.app.component.card.text.color};
    font-size: ${(props) => props.theme.app.component.card.text.size};
    font-weight: ${(props) => props.theme.app.component.card.text.weight};
`;
